<template>
  <div class="warehouseDeliveryDetail">
    <van-form label-width="120px">
      <div v-if="form.menuState == 4 || form.menuState == 5">
        <van-field
          v-model="form.WarehouseWorkNumber"
          :label="$t.warehouse.warehouseWorkNumber"
          label-class="number-label"
          readonly
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              @click="onCopy(form.WarehouseWorkNumber)"
              v-if="form.WarehouseWorkNumber"
              >{{ $t.meta.copy }}</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="form.OutboundNumber"
          :label="$t.warehouse.outboundNumber"
          readonly
        />
        <van-field
          v-model="form.WarehouseCode"
          :label="$t.warehouse.warehouseCode"
          readonly
        />
        <van-field
          v-model="form.WarehouseUseTypeStr"
          :label="$t.warehouse.warehouseUseType"
          readonly
        />
        <van-field
          v-model="form.CompanyName"
          :label="$t.warehouse.billEnterprise"
          type="textarea"
          rows="3"
          readonly
        />
        <van-field
          v-model="form.OutboundCategoryStr"
          :label="$t.warehouse.warehousingType"
          readonly
        />
        <van-field
          v-model="form.OutboundTime"
          :label="$t.warehouse.outBoundTime"
          readonly
        />
        <van-field
          v-model="form.ProductsName"
          :label="$t.warehouse.goodsName"
          type="textarea"
          rows="3"
          readonly
        />
        <van-field v-model="form.Number" :label="$t.warehouse.pNumber" readonly />
        <van-field v-model="form.NumberUnit" :label="$t.warehouse.piecesUnit" readonly />
        <van-field
          :value="form.Weight ? form.Weight + ' KG' : ''"
          :label="$t.warehouse.weight"
          readonly
        />
        <van-field
          :value="form.Volume ? form.Volume + ' m³' : ''"
          :label="$t.warehouse.volume"
          readonly
        />
        <van-field
          v-model="form.StorageArea"
          :label="$t.warehouse.storageArea"
          readonly
        />
        <van-field
          :value="form.StorageTime + ' ' + $t.meta.day"
          :label="$t.warehouse.storageTime"
          readonly
        />
      </div>
      <div v-else-if="form.menuState == 3">
        <van-field
          v-model="form.WarehouseWorkNumber"
          :label="$t.warehouse.warehouseWorkNumber"
          label-class="number-label"
          readonly
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              @click="onCopy(form.WarehouseWorkNumber)"
              v-if="form.WarehouseWorkNumber"
              >{{ $t.meta.copy }}</van-button
            >
          </template>
        </van-field>
        <van-field v-model="form.CreateTime" :label="$t.warehouse.createTime" readonly />
        <van-field
          v-model="form.OperationTypeStr"
          :label="$t.warehouse.operation"
          readonly
        />
        <van-field
          v-model="form.OutboundNumber"
          :label="$t.warehouse.outboundNumber"
          readonly
        />
        <van-field v-model="form.BoxName" :label="$t.warehouse.boxName" readonly />
        <van-field
          v-model="form.ProductName"
          :label="$t.warehouse.goodsNameSn"
          readonly
        />
        <van-field v-model="form.Brand" :label="$t.warehouse.brand" readonly />
        <van-field v-model="form.Model" :label="$t.warehouse.model" readonly />
        <van-field
          v-model="form.OutboundQuantity"
          :label="$t.warehouse.exportNumber"
          readonly
        />
        <van-field
          v-model="form.InventoryQuantity"
          :label="$t.warehouse.inventory"
          readonly
        />
        <van-field v-model="form.UnitPrice" :label="$t.warehouse.goodsValue" readonly />
        <van-field :value="form.Long + ' cm'" :label="$t.warehouse.long" readonly />
        <van-field :value="form.Wide + ' cm'" :label="$t.warehouse.width" readonly />
        <van-field :value="form.Height + ' cm'" :label="$t.warehouse.height" readonly />
        <van-field
          :value="form.StorageTime + ' ' + $t.meta.day"
          :label="$t.warehouse.storageTime"
          readonly
        />

        <van-field :label="$t.warehouse.productImage">
          <template #input>
            <van-image
              width="80"
              height="80"
              fit="cover"
              @click="imagePreview(imgUrlFilter(form.ProductPictures))"
              :src="imgUrlFilter(form.ProductPictures)"
              v-if="form.ProductPictures"
            />
            <span v-else>{{ $t.warehouse.noImage }}</span>
          </template>
        </van-field>
      </div>
      <div v-else-if="form.menuState == 2">
        <van-field
          v-model="form.WarehouseWorkNumber"
          :label="$t.warehouse.warehouseWorkNumber"
          label-class="number-label"
          readonly
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              @click="onCopy(form.WarehouseWorkNumber)"
              v-if="form.WarehouseWorkNumber"
              >{{ $t.meta.copy }}</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="form.OutboundStateStr"
          :label="$t.warehouse.status"
          readonly
        />
        <van-field
          v-model="form.WarehouseUseTypeStr"
          :label="$t.warehouse.warehouseUseType"
          readonly
        />
        <van-field
          v-model="form.WarehouseCode"
          :label="$t.warehouse.warehouseCode"
          readonly
        />
        <van-field
          v-model="form.CompanyName"
          :label="$t.warehouse.billEnterprise"
          type="textarea"
          rows="3"
          readonly
        />
        <van-field v-model="form.TotalBatch" :label="$t.warehouse.batch" readonly />
        <van-field
          v-model="form.CreateTime"
          :label="$t.warehouse.InStorageTime"
          readonly
        />
        <van-field v-model="form.ProductsName" :label="$t.warehouse.goodsName" readonly />
        <van-field
          v-model="form.ActualDeliveryQuantity"
          :label="$t.warehouse.pNumber"
          readonly
        />
        <van-field
          :value="(form.IncomingWeight ? form.IncomingWeight : '') + ' KG'"
          :label="$t.warehouse.weight"
          readonly
        />
        <van-field
          :value="(form.IncomingVolume ? form.IncomingVolume : '') + ' m³'"
          :label="$t.warehouse.volume"
          readonly
        />
        <van-field
          v-model="form.StorageArea"
          :label="$t.warehouse.storageArea"
          readonly
        />
        <van-field
          :value="form.StorageTime + ' ' + $t.meta.day"
          :label="$t.warehouse.storageTime"
          readonly
        />
      </div>
      <div v-else>
        <div class="title">{{ $t.meta.basicTitle }}</div>
        <van-field
          v-model="form.WarehouseNumber"
          :label="$t.warehouse.warehouseNumber"
          readonly
        />
        <van-field
          v-model="form.WarehouseCode"
          :label="$t.warehouse.warehouseCode"
          readonly
        />
        <van-field
          v-model="form.WarehouseUseTypeStr"
          :label="$t.warehouse.warehouseUseType"
          readonly
        />
        <van-field v-model="form.TotalBatch" :label="$t.warehouse.batch" readonly />
        <van-field
          v-model="form.AppointmentStorageTime"
          :label="$t.warehouse.warehousingTime"
          readonly
        />
        <van-field
          v-model="form.CompanyName"
          :label="$t.warehouse.billEnterprise"
          type="textarea"
          rows="3"
          readonly
        />
        <van-field
          v-model="form.OperationUserName"
          :label="$t.warehouse.bContact"
          readonly
        />
        <van-field
          v-model="form.OperationPhoneNumber"
          :label="$t.warehouse.bPhone"
          readonly
        />
        <van-field
          v-model="form.GoodBatchReferenceNumber"
          :label="$t.warehouse.batchRefNumber"
          readonly
        />
        <div class="title">{{ $t.warehouse.expressTitle }}</div>
        <van-field
          v-model="form.ExpressCompanyName"
          :label="$t.warehouse.expressCompany"
          readonly
        />
        <van-field
          v-model="form.ExpressNumber"
          :label="$t.warehouse.expressNumber"
          readonly
        />

        <div class="title">{{ $t.warehouse.deliveryTitle }}</div>
        <van-field
          v-model="form.EmergencyContactPerson"
          :label="$t.warehouse.emergencyPerson"
          readonly
        />
        <van-field
          v-model="form.EmergencyContactPhone"
          :label="$t.warehouse.emergencyPhone"
          readonly
        />
        <van-field
          v-model="form.DeliveryLicensePlateNumber"
          :label="$t.warehouse.plate"
          readonly
        />

        <div class="title">{{ $t.warehouse.cargoTitle }}</div>
        <van-field v-model="form.ProductsName" :label="$t.warehouse.goodsName" readonly />
        <van-field v-model="form.TotalNumber" :label="$t.warehouse.esPackage" readonly />
        <van-field v-model="form.TotalWeight" :label="$t.warehouse.esWeight" readonly />
        <van-field v-model="form.TotalVolume" :label="$t.warehouse.esVolume" readonly />
      </div>
    </van-form>

    <van-dialog
      :title="$t.warehouse.sheet1"
      width="90%"
      v-model="expressVisible"
      @confirm="expressConfirm"
      @cancel="expressCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="warehouseDeliveryDetail-alert">
          <van-form label-width="120px">
            <van-field
              v-model="expressForm.ExpressCompanyName"
              :label="$t.warehouse.expressCompany"
              required
            />
            <van-field
              v-model="expressForm.ExpressNumber"
              :label="$t.warehouse.expressNumber"
              required
            />
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.warehouse.sheet2"
      width="90%"
      v-model="plateVisible"
      @confirm="plateConfirm"
      @cancel="plateCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="warehouseDeliveryDetail-alert">
          <van-form label-width="120px">
            <van-field
              v-model="plateForm.EmergencyContactPerson"
              :label="$t.warehouse.bContact"
              required
            />
            <van-field
              v-model="plateForm.EmergencyContactPhone"
              :label="$t.warehouse.bPhone"
            />
            <van-field
              v-model="plateForm.DeliveryLicensePlateNumber"
              :label="$t.warehouse.plate"
            />
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.warehouse.arrive"
      width="90%"
      v-model="dialogVisible"
      @confirm="dialogConfirm"
      @cancel="dialogCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="warehouseDeliveryDetail-alert">
          <van-form label-width="160px">
            <van-field
              v-model="dialogForm.TotalNumber"
              :label="$t.warehouse.esPackage"
              readonly
            />

            <van-field
              v-model="dialogForm.ActualDeliveryQuantity"
              :label="$t.warehouse.adQuantity"
              required
            />

            <van-field
              v-model="dialogForm.NumberUnit"
              :label="$t.warehouse.piecesUnit"
              required
            />

            <van-field
              v-model="dialogForm.TotalVolume"
              :label="$t.warehouse.esVolume"
              readonly
            />

            <van-field
              v-model="dialogForm.IncomingVolume"
              :label="$t.warehouse.incomingVolume"
              required
            />

            <van-field
              v-model="dialogForm.TotalWeight"
              :label="$t.warehouse.esWeight"
              readonly
            />

            <van-field
              v-model="dialogForm.IncomingWeight"
              :label="$t.warehouse.incomingWeight"
              required
            />

            <div class="custom-date">
              <div class="date-btn1">{{ $t.warehouse.ata }}</div>
              <div class="date-btn2" @click="showTimeDate">
                <span v-if="dialogForm.ActualTimeArrival">{{
                  dialogForm.ActualTimeArrival
                }}</span>
                <span v-else class="placeholder">{{ $t.meta.select }}</span>
              </div>
            </div>

            <div class="multi-table" v-if="dialogForm.FileList">
              <van-field name="stepper" :label="$t.warehouse.warehousingPhoto">
                <template #input>
                  <van-stepper
                    :min="0"
                    :value="dialogForm.FileList.length"
                    @minus="handleDel"
                    @plus="handleAdd"
                    :disable-input="true"
                  />
                </template>
              </van-field>
              <div v-for="(item, index) in dialogForm.FileList" :key="index">
                <div class="multi-table-header">
                  <div class="multi-table-title"></div>
                  <div class="multi-table-btn" @click="handleDelByIndex(index)">
                    <van-icon name="close" />
                  </div>
                </div>
                <van-field :label="$t.warehouse.photo + (index + 1)">
                  <template #input>
                    <van-button
                      @click="imagePreview(imgUrlFilter(item.FileAddress))"
                      type="primary"
                      size="small"
                      style="vertical-align: top; margin: 10px 30px 10px 0px"
                      v-if="item.FileAddress"
                      >{{ $t.meta.view }}</van-button
                    >
                    <van-uploader
                      :after-read="afterRead1"
                      @click-upload="uploaderClick(index)"
                    >
                      <van-image
                        :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                        width="50"
                        height="50"
                        fit="contain"
                        style="vertical-align: top"
                        v-if="item.FileAddress"
                      ></van-image>
                      <van-button
                        type="info"
                        size="small"
                        style="vertical-align: top; margin: 10px 30px 10px 0px"
                        v-else
                        >{{ $t.meta.upload }}</van-button
                      >
                    </van-uploader>
                  </template>
                </van-field>
              </div>
            </div>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        type="datetime"
        :title="$t.warehouse.ata"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-action-sheet v-model="sheetShow" :actions="sheetActions" @select="sheetSelect" />

    <div class="tool-bar" v-if="form.menuState != 3">
      <van-button type="info" block @click="handleSheetShow">{{
        $t.meta.menu
      }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Uploader,
  Picker,
  Popup,
  Stepper,
  ActionSheet,
  DatetimePicker,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Uploader)
  .use(Picker)
  .use(Popup)
  .use(Stepper)
  .use(ActionSheet)
  .use(DatetimePicker);

export default {
  name: "warehouseDeliveryDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
      expressVisible: false,
      expressForm: {
        WHAFId: "",
        ExpressCompanyName: "",
        ExpressNumber: "",
      },
      plateVisible: false,
      plateForm: {
        WHAFId: "",
        EmergencyContactPerson: "",
        EmergencyContactPhone: "",
        DeliveryLicensePlateNumber: "",
      },
      dialogVisible: false,
      dialogForm: {
        WHAFId: "",
        TotalNumber: "",
        TotalWeight: "",
        TotalVolume: "",
        ActualDeliveryQuantity: "",
        NumberUnit: "",
        IncomingVolume: "",
        IncomingWeight: "",
        ActualTimeArrival: "",
        FileList: [],
      },
      //操作菜单
      sheetShow: false,
      sheetActions: [],
      //日期
      selectDate: new Date(),
      currentDate: "",
      showTimePicker: false,
      //上传
      filesIndex: 0,
    };
  },
  created() {
    var data = JSON.parse(localStorage.getItem("warehouseDeliveryDetail"));
    this.form = data;
  },
  methods: {
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    toBillsReceivable() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "billsReceivable",
        name: "billsReceivable",
        query: [
          {
            name: "WGId",
            value: this.form.WGId,
          },
        ],
      });
    },
    toSupplierCostEntry() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "supplierCostEntry",
        name: "supplierCostEntry",
        query: [
          {
            name: "WGId",
            value: this.form.WGId,
          },
        ],
      });
    },
    gotoWarehouseBill() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "warehouseBill",
        name: "warehouseBill",
        query: [
          {
            name: "WHAFId",
            value: this.form.WHAFId,
          },
        ],
      });
    },
    gotoWarehouseBillDetail(type) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "warehouseBillDetail",
        name: "warehouseBillDetail",
        query: [
          {
            name: "Type",
            value: type,
          },
          {
            name: "WGId",
            value: this.form.WGId,
          },
          {
            name: "WOId",
            value: this.form.WOId,
          },
        ],
      });
    },
    showTimeDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showTimePicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        var hour = value.getHours() < 10 ? "0" + value.getHours() : value.getHours();
        var minute =
          value.getMinutes() < 10 ? "0" + value.getMinutes() : value.getMinutes();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date + " " + hour + ":" + minute;
      };
      this.dialogForm.ActualTimeArrival = formatDate(date);
      this.showTimePicker = false;
    },
    plateShow() {
      this.plateVisible = true;
      this.plateForm.WHAFId = this.form.WHAFId;
      this.plateForm.EmergencyContactPerson = this.form.EmergencyContactPerson;
      this.plateForm.EmergencyContactPhone = this.form.EmergencyContactPhone;
      this.plateForm.DeliveryLicensePlateNumber = this.form.DeliveryLicensePlateNumber;
    },
    plateConfirm() {
      this.$commonMethod.showLoading();
      var param = this.plateForm;
      this.$api.storage
        .editWarehousingApplyForDeliveryInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.form.EmergencyContactPerson = this.plateForm.EmergencyContactPerson;
          this.form.EmergencyContactPhone = this.plateForm.EmergencyContactPhone;
          this.form.DeliveryLicensePlateNumber = this.plateForm.DeliveryLicensePlateNumber;
          this.plateCancel();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    plateCancel() {
      this.plateVisible = false;
      for (let key in this.plateForm) {
        this.plateForm[key] = "";
      }
    },
    expressShow() {
      this.expressVisible = true;
      this.expressForm.WHAFId = this.form.WHAFId;
      this.expressForm.ExpressCompanyName = this.form.ExpressCompanyName;
      this.expressForm.ExpressNumber = this.form.ExpressNumber;
    },
    expressConfirm() {
      this.$commonMethod.showLoading();
      var param = this.expressForm;
      this.$api.storage
        .editWarehousingApplyForExpressInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.form.ExpressCompanyName = this.expressForm.ExpressCompanyName;
          this.form.ExpressNumber = this.expressForm.ExpressNumber;
          this.expressCancel();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    expressCancel() {
      this.expressVisible = false;
      for (let key in this.expressForm) {
        this.expressForm[key] = "";
      }
    },
    dialogShow() {
      this.dialogVisible = true;
      this.dialogForm.WHAFId = this.form.WHAFId;
      this.dialogForm.TotalNumber = this.form.TotalNumber;
      this.dialogForm.TotalWeight = this.form.TotalWeight;
      this.dialogForm.TotalVolume = this.form.TotalVolume;
    },
    dialogConfirm() {
      this.$commonMethod.showLoading();
      var param = this.dialogForm;
      this.$api.storage
        .addWarehousingGood(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogCancel() {
      this.dialogVisible = false;
      for (let key in this.dialogForm) {
        this.dialogForm[key] = "";
      }
      this.dialogForm.FileList = [];
    },
    sheetSelect(e) {
      if (this.form.menuState == 1) {
        if (e.className == "1") {
          this.expressShow();
        }
        if (e.className == "2") {
          this.plateShow();
        }
        if (e.className == "3") {
          this.gotoWarehouseBill();
        }
        if (e.className == "4") {
          this.dialogShow();
        }
      }
      if (this.form.menuState == 2) {
        if (e.className == "1") {
          this.gotoWarehouseBillDetail("add");
        }
        if (e.className == "2") {
          this.toBillsReceivable();
        }
        if (e.className == "3") {
          this.toSupplierCostEntry();
        }
        if (e.className == "4") {
          this.gotoWarehouseBillDetail("detail");
        }
      }
      if (this.form.menuState == 4) {
        if (e.className == "1") {
          this.gotoWarehouseBillDetail("wd");
        }
        if (e.className == "2") {
          this.toBillsReceivable();
        }
        if (e.className == "3") {
          this.toSupplierCostEntry();
        }
        if (e.className == "4") {
          this.gotoWarehouseBillDetail("detail");
        }
      }
      if (this.form.menuState == 5) {
        if (e.className == "1") {
          this.gotoWarehouseBillDetail("os");
        }
        if (e.className == "2") {
          this.toBillsReceivable();
        }
        if (e.className == "3") {
          this.toSupplierCostEntry();
        }
        if (e.className == "4") {
          this.gotoWarehouseBillDetail("detail");
        }
      }
      this.sheetShow = false;
    },
    handleSheetShow() {
      var actions = [];
      if (this.form.menuState == 1) {
        actions = [
          { name: this.$t.warehouse.sheet1, className: "1" },
          { name: this.$t.warehouse.sheet2, className: "2" },
          { name: this.$t.warehouse.sheet3, className: "3" },
          { name: this.$t.warehouse.arrive, className: "4" },
        ];
      }
      if (this.form.menuState == 2) {
        actions = [
          { name: this.$t.warehouse.outbound, className: "1" },
          { name: this.$t.warehouse.sheet4, className: "2" },
          { name: this.$t.warehouse.sheet5, className: "3" },
          { name: this.$t.warehouse.sheet6, className: "4" },
        ];
      }
      if (this.form.menuState == 4 || this.form.menuState == 5) {
        actions = [
          { name: this.$t.warehouse.viewApply, className: "1" },
          { name: this.$t.warehouse.sheet4, className: "2" },
          { name: this.$t.warehouse.sheet5, className: "3" },
          { name: this.$t.warehouse.sheet6, className: "4" },
        ];
      }
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    handleDelByIndex(index) {
      if (this.dialogForm.FileList.length > 0) {
        this.dialogForm.FileList.splice(index, 1);
      }
    },
    handleDel() {
      if (this.dialogForm.FileList.length > 0) {
        this.dialogForm.FileList.pop();
      }
    },
    handleAdd() {
      this.dialogForm.FileList.push({
        FileAddress: "",
      });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.dialogForm.FileList[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.warehouseDeliveryDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .warehouseDeliveryDetail-alert {
    overflow: scroll;
    max-height: 100vw;
    margin-top: 20px;
    margin-bottom: 20px;
    .custom-date {
      padding: 12px 16px;
      border-bottom: 1px solid #ebedf0;
      .date-btn1 {
        width: 33%;
        display: inline-block;
        margin-right: 5%;
        font-size: 14px;
        color: #646566;
      }
      .date-btn2 {
        width: 62%;
        display: inline-block;
        font-size: 14px;
        .value {
          color: #323233;
        }
        .placeholder {
          color: #c3c3c3;
        }
      }
    }
    .multi-table {
      .multi-table-header {
        padding: 10px 15px;
        .multi-table-title {
          font-size: 14px;
          color: #999;
          width: 70%;
          display: inline-block;
          vertical-align: middle;
        }
        .multi-table-btn {
          font-size: 20px;
          color: #000;
          width: 30%;
          display: inline-block;
          text-align: right;
          vertical-align: middle;
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
